import React, { Component } from "react";

import { getSentimentColor, downloadCSVData, downloadCanvasWithTitle, numberWithCommas, kmFormatter } from "../utils";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class TopicWiseSentimentBreakupChart extends React.PureComponent {
    state = {};
    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    optionsOverTime = () => {
        //let data = this.props.data.data;
        let { positive, negative, neutral, maxpositive, maxnegative, maxneutral } = this.props.data;
        let positiveData = this.props.expandWidget ? JSON.parse(JSON.stringify(maxpositive)) : JSON.parse(JSON.stringify(positive));
        let negativeData = this.props.expandWidget ? JSON.parse(JSON.stringify(maxnegative)) : JSON.parse(JSON.stringify(negative));
        let neutralData = this.props.expandWidget ? JSON.parse(JSON.stringify(maxneutral)) : JSON.parse(JSON.stringify(neutral));

        // console.log("positiveData", positiveData);
        let self = this;
        const chartConfig = {
            chart: {
                type: "bar",
                // height: 70 * data.keys.length,
                // width: 1000,
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                scrollablePlotArea: {
                    minHeight: this.props.expandWidget ? maxpositive.length * 55 : positive.length,
                    opacity: 1,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            xAxis: {
                type: "category",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
                labels: {
                    formatter: function () {
                        if (this.value != "others") {
                            let label = this.chart.userOptions.series[0].data.find((ele) => ele.name == this.value);

                            return label.labelName.length > 25 ? label.labelName.substring(0, 24) + "..." : label.labelName;
                        } else {
                            return "Others";
                        }
                    },
                },
                // gridLineWidth:  2 ,
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            legend: {
                enabled: this.props.showLegend,
                align: "center",
            },
            series: [
                {
                    name: "Positive",
                    data: positiveData,
                    dataLabels: {
                        x: 10,
                        formatter: function (e) {
                            return `<p>${kmFormatter(this.point.doc_count)}</p><br/>`;
                        },
                    },
                    color: getSentimentColor("positive"),
                    marker: {
                        fillColor: getSentimentColor("positive"),
                        symbol: "square",
                    },
                },
                {
                    name: "Negative",
                    data: negativeData,
                    color: getSentimentColor("negative"),
                    dataLabels: {
                        x: 10,
                        formatter: function (e) {
                            return `<p>${kmFormatter(this.point.doc_count)}</p><br/>`;
                        },
                    },
                    marker: {
                        fillColor: getSentimentColor("negative"),
                        symbol: "square",
                    },
                },
                {
                    name: "Neutral",
                    data: neutralData,
                    dataLabels: {
                        x: 10,
                        formatter: function (e) {
                            return `<p>${kmFormatter(this.point.doc_count)}</p><br/>`;
                        },
                    },
                    color: getSentimentColor("neutral"),
                    marker: {
                        fillColor: getSentimentColor("neutral"),
                        symbol: "square",
                    },
                },
            ],
            plotOptions: {
                series: {
                    minPointLength: 8,
                    pointWidth: 10,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        style: {
                            textOutline: "none",
                        },
                    },
                },
                bar: {
                    borderWidth: 0,
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            tooltip: {
                shared: true,
                followPointer: true,
                followTouchMove: true,

                // followPointer: true,
                // headerFormat: '<b style="font-size: 15px;">{point.key}</b><br /><br />',
                //headerFormat: '<span style="padding-bottom: 20px;">{point.key}</span><br />',
                borderColor: "white",
                useHtml: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                // pointFormat:
                //     '<span margin-top: 24px;">{series.name}</span>: <b>{point.percentage}%</b> | <b style="margin-bottom: 24px;">{point.doc_count}/{point.totalData}</b><br/>',

                formatter: function () {
                    let tot = 0;
                    let sentiment = { positive: { value: 0, percentage: 0 }, negative: { value: 0, percentage: 0 }, neutral: { value: 0, percentage: 0 } };
                    this.points.map((point) => {
                        tot += point.y;
                        sentiment[point.point.sentiment].value = point.y;
                    });

                    let labelValue = this.points[0].series.userOptions.data.find((ele) => ele.name == this.points[0].key);

                    sentiment.positive.percentage = sentiment.positive.value ? ((sentiment.positive.value / tot) * 100).toFixed(2) : 0;
                    sentiment.negative.percentage = sentiment.negative.value ? ((sentiment.negative.value / tot) * 100).toFixed(2) : 0;
                    sentiment.neutral.percentage = sentiment.neutral.value ? ((sentiment.neutral.value / tot) * 100).toFixed(2) : 0;
                    return `<span>${labelValue ? labelValue.labelName : "Others"}</span><br /><span>Positive: <b>${sentiment.positive.percentage}%</b> | 
                   </span> <span><b>${numberWithCommas(sentiment.positive.value)}</b> / <b>${numberWithCommas(tot)}</b></span><br />
                   <span>Negative: <b>${sentiment.negative.percentage}%</b> | 
                   </span> <span><b>${numberWithCommas(sentiment.negative.value)}</b> / <b>${numberWithCommas(tot)}</b></span><br />
                   <span>Neutral: <b>${sentiment.neutral.percentage}%</b> | 
                   </span> <span> <b>${numberWithCommas(sentiment.neutral.value)}</b> / <b>${numberWithCommas(tot)}</b></span><br />
                    `;
                },

                style: {
                    // fontSize: "13px",
                    fontWeight: "normal",
                    paddingBottom: 12,
                },
            },
        };

        return chartConfig;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.optionsOverTime()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default TopicWiseSentimentBreakupChart;
